import Button from "../../../../Custom/Button/Button";
import { useGlobalContext } from "../../../../../Context/Context";

const styles = {
  button: {
    padding: "5px 30px",
    fontWeight: "bold"
  }
};

function ButtonsOneChecked({
  handleClickNazad,
  handleOpenEdit,
  handleOpenPrikaz,
  handleOpenDelete
}) {
  const { dictionary } = useGlobalContext();

  return (
    <>
      <div onClick={handleOpenPrikaz} style={{ width: "25%" }}>
        <Button activation={true} style={styles.button}>
          {dictionary["prikazi"]}
        </Button>
      </div>
      <div onClick={handleOpenDelete} style={{ width: "25%" }}>
        <Button activation={true} style={styles.button}>
          {dictionary["izbrisi"]}
        </Button>
      </div>
      <div onClick={handleClickNazad} style={{ width: "25%" }}>
        <Button activation={true} style={styles.button}>
          {dictionary["nazad"]}
        </Button>
      </div>
      <div onClick={handleOpenEdit} style={{ width: "25%" }}>
        <Button activation={true} style={styles.button}>
          {dictionary["izmeni"]}
        </Button>
      </div>
    </>
  );
}

export default ButtonsOneChecked;
